import { render, staticRenderFns } from "./VipYearButton.vue?vue&type=template&id=271255e6&"
import script from "./VipYearButton.vue?vue&type=script&lang=js&"
export * from "./VipYearButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports